export default {"src":"/_next/static/media/image 4.bad5a11c.svg","height":30,"width":36,"blurWidth":0,"blurHeight":0};